import React, { useState, useCallback, useRef, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import Toolbar, { Item } from "devextreme-react/toolbar";
import PrimaryTab from "./tabs/PrimaryTab";
import DetailTab from "./tabs/DetailTab";
import axios from "axios";
import data from "../../../../assets/apiRoutes.json";
import notify from 'devextreme/ui/notify';

function Form(props) {
    const history = useHistory();
    const formRefs = useRef({});
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        RECORD: '',
        RATECODE: '',
        DESCRIPTION: '',
        STATUS: 'A',
        COMMENT: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const accessToken = props?.oidc?.user?.access_token;

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const position = { of: '#accordion' };

    const handleFieldChange = useCallback((name, value) => {
        setformFields(prevFields => ({
            ...prevFields,
            [name]: value
        }));
    }, []);

    const loadRateCodeById = useCallback(async (rowId) => {
        if (!rowId || rowId === '00000000-0000-0000-0000-000000000000') {
            return;
        }

        try {
            setLoadPanelVisible(true);
            const url = `${window._env_.REACT_APP_APIS}/${data.RateCode.GetRateCode}?rowid=${rowId}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data) {
                const rateCode = response.data;
                setformFields({
                    ROWID: rateCode.RowId || initialFormFields.ROWID,
                    RECORD: rateCode.RecordNumber || '',
                    RATECODE: rateCode.RateCode || '',
                    DESCRIPTION: rateCode.Description || '',
                    STATUS: rateCode.Status || 'A',
                    COMMENT: rateCode.Comment || '',
                });
            }
        } catch (error) {
            console.error('Error loading Rate Code:', error);
            notify('Failed to load Rate Code data.', 'error', 3000);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    useEffect(() => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadRateCodeById(rowId);
        }
    }, [props.id, loadRateCodeById]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoadPanelVisible(true);

        try {
            const payload = {
                RowId: formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000" ? formFields.ROWID : "00000000-0000-0000-0000-000000000000",
                KeySequence: 0,
                RateCode: formFields.RATECODE || "",
                Description: formFields.DESCRIPTION || "",
                Status: formFields.STATUS || "A",
                Comment: formFields.COMMENT || "",
            };

            const isUpdate = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
            const endpoint = isUpdate ? data.RateCode.UpdateRateCode : data.RateCode.InsertRateCode;
            const method = isUpdate ? 'put' : 'post';

            const url = `${window._env_.REACT_APP_APIS}/${endpoint}`;
            const resp = await axios[method](url, payload, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                }
            });

            const saved = resp?.data;
            if (saved) {
                setformFields((prev) => ({
                    ...prev,
                    ROWID: saved.RowId || prev.ROWID,
                    RECORD: saved.RecordNumber || prev.RECORD,
                    RATECODE: saved.RateCode || prev.RATECODE,
                    DESCRIPTION: saved.Description || prev.DESCRIPTION,
                    STATUS: saved.Status || prev.STATUS,
                    COMMENT: saved.Comment || prev.COMMENT,
                }));
            }

            notify("Rate Code saved successfully.", "success", 3000);
        } catch (err) {
            const message =
                err?.response?.data?.message ||
                (typeof err?.response?.data === "string" ? err.response.data : null) ||
                err?.message ||
                "Failed to save Rate Code.";

            notify(message, "error", 5000);
        } finally {
            hideLoadPanel();
        }
    };

    const addNewRecordClick = () => {
        setformFields(initialFormFields);
    };

    const handleReset = () => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadRateCodeById(rowId);
        } else {
            setformFields(initialFormFields);
        }
    };

    const goBack = () => {
        history.push("/wm/codes/rate-codes");
    };

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Rate Code
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="Details" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                    <DetailTab
                                        headerId={formFields.ROWID}
                                    />
                                </TabItem>
                            </TabPanel>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(Form);
